import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Application } from 'src/app/account/services/application.service'
import { SyncPairPermissionIssue } from 'src/app/account/services/issue'
import { SyncPair } from 'src/app/account/services/sync-pair.service'
import { UiService } from 'src/app/services/ui.service'
import { environment } from 'src/environments/environment'
import { CopyFeedbackService } from 'src/app/shared/copy-feedback.service'

@Component({
  selector: 'iam-permission-issue',
  templateUrl: './iam-permission-issue.component.html',
  styleUrls: ['./iam-permission-issue.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [CopyFeedbackService],
})
export class IamPermissionIssueComponent implements OnInit {
  @Input() issue: SyncPairPermissionIssue = null
  @Input('sync-pair') syncPair: SyncPair = null
  @Input('application') application: Application = null

  private _manualResourceTemplate: string = null

  constructor(
    public uiService: UiService,
    public copyFeedback: CopyFeedbackService
  ) {}

  ngOnInit() {
    let manualResourceTemplateUrl$ = !!this.syncPair
      ? this.syncPair.manualResourceTemplateUrl$
      : this.application.manualResourceTemplateUrl$
    manualResourceTemplateUrl$.subscribe((template) => (this._manualResourceTemplate = template))
  }

  get sourceRegion() {
    return !!this.syncPair ? this.syncPair.sourceRegion : this.application.sourceRegion
  }

  get sourceAwsAccountId() {
    return !!this.syncPair ? this.syncPair.sourceAwsAccountId : this.application.sourceAwsAccountId
  }

  get targetRegion() {
    return !!this.syncPair ? this.syncPair.targetRegion : this.application.targetRegion
  }

  get targetAwsAccountId() {
    return !!this.syncPair ? this.syncPair.targetAwsAccountId : this.application.targetAwsAccountId
  }

  get productName() {
    return environment.productName
  }

  get manualResourceTemplateUrl() {
    if (this._manualResourceTemplate == null) {
      return ''
    }
    return this._manualResourceTemplate
  }

  get manualResourceTemplateName() {
    let url = this.manualResourceTemplateUrl
    if (url) {
      return url.slice(url.lastIndexOf('/') + 1)
    }
    return 'Loading templates...'
  }

  get suggestedStackName() {
    // Computes a stack name so that customers don't have to track which stack
    // relates to which sync.  Assumes the stack is always installed in the target
    // region so omits target endpont info.
    let accountId = !!this.syncPair ? this.syncPair.accountId : this.application.accountId
    let accountIdAbbreviated = accountId.slice(-5)
    let awsAccountId = this.sourceAwsAccountId
    let region = this.sourceRegion
    return `ArpioResources-${awsAccountId}-${region}-${accountIdAbbreviated}`
  }
}
